import Vue from "vue";
import firebase from "firebase";

const loadAutoCompletesData = "loadAutoCompletesData";
const clearAutoCompletesData = "clearAutoCompletesData";
const updateAutoCompleteData = "updateAutoCompleteData";
const createAutoCompleteData = "createAutoCompleteData";

const SET_AUTO_COMPLETES_DATA = "SET_AUTO_COMPLETES_DATA";
const SET_AUTO_COMPLETE_DATA = "SET_AUTO_COMPLETE_DATA";
const CLEAR_AUTO_COMPLETES_DATA = "CLEAR_AUTO_COMPLETES_DATA";

const getAutoCompleteData = "getAutoCompleteData";

const Autocompletions = "Autocompletions";

const COLLECTION_NAME = "configuration/customerData/autocompletion";

export const api = {
  namespace: "autocompletes",
  actions: {
    loadAutoCompletesData,
    clearAutoCompletesData,
    updateAutoCompleteData,
    createAutoCompleteData
  },
  mutations: {
    SET_AUTO_COMPLETES_DATA,
    CLEAR_AUTO_COMPLETES_DATA,
    SET_AUTO_COMPLETE_DATA
  },
  getters: {
    getAutoCompleteData
  },
  state: {
    Autocompletions
  }
};

export function validatingCastIdName(data, idx) {
  if (
    data instanceof Object &&
    typeof data.id === "string" &&
    typeof data.name === "string"
  ) {
    return data;
  } else {
    const errorMsg = `AutoComplete data[${idx}] invalid: data to be an array of {id: string; name: string;}`;
    console.error(errorMsg, data);
    throw new TypeError(errorMsg);
  }
}

export function validatingCastAutoComplete(data) {
  if (!(data instanceof Object)) {
    throw new TypeError("AutoComplete data invalid: expect object");
  }

  if (
    !(data.data instanceof Array) ||
    !data.data.every((v, i) => validatingCastIdName(v, i))
  ) {
    throw new TypeError(
      "AutoComplete data invalid: expect data to be an array"
    );
  }
  return data;
}

const actions = {
  async [api.actions.loadAutoCompletesData](context) {
    console.log("loadAutoCompletesData", context);
    const collection = firebase.firestore().collection(COLLECTION_NAME);
    const snapshot = await collection.get();

    const docs = snapshot.docs;

    const data = {};
    docs.forEach(doc => {
      data[doc.id] = validatingCastAutoComplete(doc.data());
    });

    context.commit(SET_AUTO_COMPLETES_DATA, data);
  },

  [api.actions.clearAutoCompletesData](context) {
    console.log("clearAutoCompletesData", context);
    context.commit(CLEAR_AUTO_COMPLETES_DATA);
  },
  async [api.actions.updateAutoCompleteData](context, payload) {
    console.log("updateAutoCompleteData", context, payload);
    const data = { ...validatingCastAutoComplete(payload) };
    const docId = data.id;
    if (typeof docId !== "string" || !/^[a-z][a-z0-9]+$/.test(docId)) {
      throw new TypeError(`documentId "${docId}" is invalid`);
    }
    delete data.id;

    const collection = firebase.firestore().collection(COLLECTION_NAME);
    const docRef = collection.doc(docId);
    await docRef.set(data);

    context.commit(api.mutations.SET_AUTO_COMPLETE_DATA, { id: docId, data });
  },
  async [api.actions.createAutoCompleteData](context, payload) {
    console.log("createAutoCompleteData", context, payload);
    const data = { ...validatingCastAutoComplete(payload) };
    const docId = data.id;
    if (typeof docId !== "string" || !/^[a-z][a-z0-9]+$/.test(docId)) {
      throw new TypeError(`documentId "${docId}" is invalid`);
    }
    delete data.id;

    const collection = firebase.firestore().collection(COLLECTION_NAME);
    const docRef = collection.doc(docId);
    await docRef.set(data);

    context.commit(api.mutations.SET_AUTO_COMPLETE_DATA, { id: docId, data });
  }
};
const mutations = {
  [api.mutations.SET_AUTO_COMPLETES_DATA](state, payload) {
    Vue.set(state, api.state.Autocompletions, payload);
  },
  [api.mutations.CLEAR_AUTO_COMPLETES_DATA](state) {
    Vue.set(state, api.state.Autocompletions, {});
  },
  [api.mutations.SET_AUTO_COMPLETE_DATA](state, { id, data }) {
    console.assert(
      typeof id === "string" && data instanceof Object,
      "Invalid parameter",
      id,
      data
    );

    Vue.set(state[api.state.Autocompletions], id, data);
  }
};
const getters = {
  [api.getters.getAutoCompleteData](state, getters, rootState, rootGetters) {
    console.log("getAutoCompleteData", state, getters, rootState, rootGetters);
    return state[api.state.Autocompletions];
  }
};

const state = (() => ({
  Autocompletions: {}
}))();

export default {
  namespaced: true,
  api,
  state,
  actions,
  mutations,
  getters
};
